<div class="container-fluid">
  <div class="card item-chart-card">
    <div class="card-body">
      <div class="header">
        <div class="header-left">
          <div class="title">{{ getModeTitle() }}</div>
          <div class="subtitle">{{ getModeSubtitle() }}</div>

          <div class="view-breadcrumb" *ngIf="currentView === 'subsegment'">
            <span>Selected Segment:</span>
            <strong>{{ selectedSegment }}</strong>
          </div>
        </div>

        <div class="filters">
          <div class="mode-toggle">
            <button type="button"
                    [class.active]="selectedMode === 'top'"
                    (click)="onModeChange('top')">
              Top Selling
            </button>
            <button type="button"
                    [class.active]="selectedMode === 'bad'"
                    (click)="onModeChange('bad')">
              Low Selling
            </button>
          </div>

          <div class="filter-item">
            <label for="beginDate">Begin Date</label>
            <input id="beginDate" type="date" [(ngModel)]="beginDate" />
          </div>

          <div class="filter-item">
            <label for="endDate">End Date</label>
            <input id="endDate" type="date" [(ngModel)]="endDate" />
          </div>

          <div class="filter-item">
            <label for="statusSelect">Status</label>
            <select id="statusSelect" [(ngModel)]="selectedStatus">
              <option [ngValue]="0">All Statuses</option>
              <option *ngFor="let s of statusObj" [ngValue]="s.id">{{ s.name }}</option>
            </select>
          </div>

          <div class="filter-item top-filter">
            <label for="topCount">{{ selectedMode === 'bad' ? 'Bottom' : 'Top' }}</label>
            <select id="topCount" [(ngModel)]="topCount" (change)="onTopCountChange()">
              <option [ngValue]="10">10</option>
              <option [ngValue]="15">15</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
          </div>

          <div class="filter-actions">
            <button type="button" class="btn btn-search" (click)="onSearch()">
              Search
            </button>
          </div>
        </div>
      </div>

      <div class="kpi-row">
        <div class="kpi-box">
          <span>{{ tableScope === 'chart' ? 'Displayed Quantity' : 'Total Quantity' }}</span>
          <strong>{{ getTotalQty() | number:'1.0-0' }}</strong>
        </div>

        <div class="kpi-box">
          <span>{{ tableScope === 'chart' ? 'Displayed Amount' : 'Total Amount' }}</span>
          <strong>{{ getTotalPrice() | number:'1.2-2' }} AZN</strong>
        </div>

        <div class="kpi-box">
          <span>{{ tableScope === 'chart' ? 'Displayed Items' : 'Item Count' }}</span>
          <strong>{{ getUniqueItemCount(getTableRows()) }}</strong>
        </div>
      </div>

      <div class="loading-box" *ngIf="isLoading">
        Loading chart data...
      </div>

      <div class="chart-toolbar" *ngIf="!isLoading">
        <div class="chart-toolbar-left">
          <button *ngIf="currentView === 'subsegment'"
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="backToSegments()">
            All Segments
          </button>

          <div class="toolbar-info" *ngIf="currentView === 'segment'">
            Click any segment bar to view subsegments
          </div>

          <div class="toolbar-info" *ngIf="currentView === 'subsegment'">
            Showing subsegments for <strong>{{ selectedSegment }}</strong>
          </div>
        </div>
      </div>

      <div class="chart-section" *ngIf="!isLoading">
        <div class="section-header">
          <div>
            <div class="section-title">{{ getChartTitle() }}</div>
            <div class="section-subtitle">{{ getChartSubtitle() }}</div>
          </div>
        </div>

        <div class="chart-wrap" [style.height.px]="getChartHeight()">
          <canvas id="itemSalesChart"></canvas>
        </div>
      </div>

      <div class="table-section" *ngIf="!isLoading">
        <div class="table-toolbar">
          <div class="table-title">{{ getTableTitle() }}</div>

          <div class="table-actions">
            <div class="scope-toggle">
              <button type="button"
                      [class.active]="tableScope === 'chart'"
                      (click)="onTableScopeChange('chart')">
                Chart Items
              </button>
              <button type="button"
                      [class.active]="tableScope === 'all'"
                      (click)="onTableScopeChange('all')">
                All Items
              </button>
            </div>

            <button type="button"
                    class="btn btn-success btn-sm"
                    [disabled]="getTableRows().length === 0"
                    (click)="exportTableToExcel()">
              Export Excel
            </button>
          </div>
        </div>

        <div class="table-wrap">
          <table class="table item-table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>Group</th>
                <th>Seg. Level 1</th>
                <th>Seg. Level 2</th>
                <th>Seg. Level 3</th>
                <th class="text-right">Sold Qty</th>
                <th class="text-right">Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of getTableRows(); let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.itemCode }}</td>
                <td>{{ item.itemName }}</td>
                <td>{{ item.groupName || '-' }}</td>
                <td>{{ item.segment || '-' }}</td>
                <td>{{ item.subSegment || '-' }}</td>
                <td>{{ item.ssubSegment || '-' }}</td>
                <td class="text-right">{{ item.totalQty | number:'1.0-0' }}</td>
                <td class="text-right">{{ item.totalPrice | number:'1.2-2' }}</td>
              </tr>

              <tr *ngIf="getTableRows().length === 0">
                <td colspan="9" class="empty-row">No data found.</td>
              </tr>
            </tbody>

            <tfoot *ngIf="getTableRows().length > 0">
              <tr>
                <th colspan="7" class="text-right">Total</th>
                <th class="text-right">{{ getTotalQty() | number:'1.0-0' }}</th>
                <th class="text-right">{{ getTotalPrice() | number:'1.2-2' }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
